module.exports = __webpack_public_path__ + "media/LP_メイクモード.4f5544cc.mp4";